import { inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'adm-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
})
export class ConfirmDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);
  data = inject<{
    title: string;
    text: string;
    confirmText?: string;
    denyText?: string;
    icon?: string | { name: string };
    identifier?: {
      title: string;
      value: string;
    };
  }>(MAT_DIALOG_DATA);

  title = '';
  text = '';
  confirmText = 'Ja';
  denyText = 'Nej';
  icon: string | { name: string } = 'warning';
  identifier: { title: string; value: string } | null = null;

  ngOnInit() {
    this.text = this.data?.text;
    this.title = this.data?.title;
    this.confirmText = this.data?.confirmText ?? 'Ja';
    this.denyText = this.data?.denyText ?? 'Nej';
    this.icon = this.data?.icon ?? this.icon;
    this.identifier = this.data?.identifier ?? null;
  }

  get isStringIcon(): boolean {
    return typeof this.icon === 'string';
  }

  get isObjectIcon(): boolean {
    return typeof this.icon === 'object' && this.icon !== null;
  }

  get iconName(): string | null {
    return this.isObjectIcon ? (this.icon as { name: string }).name : null;
  }

  confirm() {
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(false);
  }
}
